import { render, staticRenderFns } from "./CompassPendingAccountData.vue?vue&type=template&id=1e31f0e4&scoped=true"
import script from "./CompassPendingAccountData.vue?vue&type=script&lang=js"
export * from "./CompassPendingAccountData.vue?vue&type=script&lang=js"
import style0 from "./CompassPendingAccountData.vue?vue&type=style&index=0&id=1e31f0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e31f0e4",
  null
  
)

export default component.exports